module.exports = __webpack_public_path__ + "ai-bot-centered-tealwp49be7c3f25da1ebf7723b064ec4e8fd6.png";